import axios from './axios.js';

//import { getNetWork, getUserInfoApi } from './app';
//import { testToken } from '../constants';

const myAxios = axios.create({
    timeout: 1000 * 10,
});

const operator = {
    source: 'h5',
    uid: 'self',
};

const handleResponseCode = code => {
    let res = true;

    switch (code) {
        // 成功
        case 200:
            res = true;
            break;
        // 没有登录
        case 401:
            // 拉起客户端登录
            // if (window.grounds?.userLogin) {
            //     userLogin();
            // } else {
            //     Alert.default({
            //         content: '当前操作需要登录账号',
            //     });
            // }

            throw new Error();

        default:
            res = false;
    }

    return res;
};

const handleResponseStatus = status => {
    if (Math.floor(status) >= 200 && Math.floor(status) < 300) {
        return true;
    }

    // http的code为500，与后端商定特殊处理
    if (status === 500) {
        // Alert.default({
        //     content: '操作失败请稍后重试',
        // });
    }

    return false;
};

export const token ='';
// '26717D7B5FABD44696DAD47F37AD869E' 圈主
// '6DEE8599706FEC79AB5F351C2294846F' 普通用户
const buildRequest = async (method, url, params, config = {}) => {
    // const netValue = await getNetWork();

    // TODO：杨冬梅，这个API暂时有问题，先屏蔽掉便于调试
    // if (netValue === 'none') {
    //     Alert.default({
    //         content: '网络开小差了，请稍后重试~',
    //     });

    //     return;
    // }

    const headers = { token, Authorization: `Bearer ${token}` };

    if (method === 'post') {
        headers['Content-type'] = 'application/json';
    }
    // eslint-disable-next-line no-undef
    const basePath = config?.basePath || circlesUrl;

    // console.log(
    //     'request params :>> ',
    //     config?.needOperator ? JSON.stringify({ operator, ...params }) : JSON.stringify(params),
    // );

    return myAxios({
        url: basePath + url,
        method,
        data: config?.needOperator ? { operator, ...params } : params,
        ...config,
        headers: { ...headers, ...config.headers },
    })
        .then(response => {
            // http code
            const res = handleResponseStatus(response.status);

            if (res) {
                // 是否需要code值
                if (config?.needCode) {
                    return response.data;
                } else if (handleResponseCode(response.data.code)) {
                    // code===200验证通过，是否需要弹出成功提示，如需要则需用户定义message
                    if (config.successMessage) {
                        // Alert.default({
                        //     content: config.successMessage,
                        // });
                    }

                    // 返回不带code的data结构体
                    return response.data.data;
                } else {
                    // Alert.default({
                    //     content: response.data.showMessage,
                    // });
                    // 直接将错误抛出
                    throw new Error(response.data.showMessage);
                }
            }

            return false;
        })
        .catch(error => {
            if (typeof axios?.isCancel === 'function' && axios.isCancel(error)) {
                throw new Error('cancel');
            } else {
                let message = '';

                if (error.hasOwnProperty('response')) {
                    handleResponseCode(error.code);
                    message = error.message;
                } else {
                    message = error.message;
                }
                throw new Error(message);
            }
        });
};

export const get = ({ url, params = {}, config }) => buildRequest('get', url, params, config);

export const post = ({ url, params = {}, config }) => buildRequest('post', url, params, config);

export default buildRequest;
